import type { ProctorSpecification } from "../../proctor/ProctorSpecification";
import type { ProctorAllocation } from "../types/JSTProctorBridge";
import { getTareBridge } from "./getTareBridge";

/**
 * This method is used to get the proctor allocations for a list of tests.
 *
 * @see JSTProctorBridge
 * @returns A promise that resolves to a list of proctor allocations
 *   - will be null if the API is unavailable
 */
export async function getProctorAllocations(
  tests: ProctorSpecification[],
): Promise<Record<string, ProctorAllocation> | null> {
  const tareBridge = getTareBridge();
  if (typeof tareBridge?.getProctorAllocations !== "function") {
    return null;
  }

  return tareBridge.getProctorAllocations(tests.map((t) => t.name));
}
